export function formatUrl (imageName: string, imageUrl: string, coordinateString?: string) {
  let formattedName = ''
  if (imageName) {
    formattedName = getUrlFormatted(imageName)
  }

  let url = imageUrl.replace('image/upload', coordinateString ? `images/${coordinateString}` : 'images')
  const index = url.lastIndexOf('.')
  url = `${url.slice(0, index)}/${formattedName}${url.slice(index)}`
  // url = url.slice(0, index) + '/' + formattedName + url.slice(index)
  return url
}

function getUrlFormatted (raw: string) {
  const currentName = `${raw}`.trim()
  const noSwedish = currentName
    .replace('Å', 'A')
    .replace('å', 'a')
    .replace('Ä', 'A')
    .replace('ä', 'a')
    .replace('Ö', 'O')
    .replace('ö', 'o')
  const noSpecialChars = noSwedish.replace(/[^A-Za-z0-9\s?]/g, '')
  const noSpace = noSpecialChars.replace(/\s+/g, '-')
  return noSpace.toLowerCase()
}